import { useState, useEffect, useCallback } from 'react';
import { getDashboardStats } from '@/api/astrologer';
import { useAuth } from '@/hooks/use-auth';

export const useDashboard = (initialPeriod = 'today') => {
  const { astrologer } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [period, setPeriod] = useState(initialPeriod);

  const fetchStats = useCallback(async () => {
    if (!astrologer?.astrologerId || !astrologer?.accessToken) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { status, data, error: apiError } = await getDashboardStats(
        astrologer.astrologerId,
        astrologer.accessToken,
        period
      );

      if (status === 200 && data) {
        setStats(data);
      } else {
        setError(apiError || 'Failed to fetch dashboard stats');
      }
    } catch (err) {
      setError(err.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  }, [astrologer?.astrologerId, astrologer?.accessToken, period]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  const changePeriod = useCallback((newPeriod) => {
    setPeriod(newPeriod);
  }, []);

  const refresh = useCallback(() => {
    fetchStats();
  }, [fetchStats]);

  return {
    stats,
    loading,
    error,
    period,
    changePeriod,
    refresh
  };
};
